/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Teal_Dog_BurnInputs */

const en_pearl_teal_dog_burn = /** @type {(inputs: Pearl_Teal_Dog_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_pearl_teal_dog_burn = /** @type {(inputs: Pearl_Teal_Dog_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Pearl_Teal_Dog_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_teal_dog_burn = /** @type {((inputs?: Pearl_Teal_Dog_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Teal_Dog_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_teal_dog_burn(inputs)
	return de_pearl_teal_dog_burn(inputs)
});